export class queryModel {
    userid:string;
    query :string;
    }